<app-spinner *ngIf="loadingSeasons"></app-spinner>

<div *ngIf="seasons && meta.totalItems > 0">
  <form [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-md-8">
        <div class="form-group">
          <div class="input-group">
            <span class="input-group-addon">
              <i class="fa fa-search" title="{{ 'NAME' | translate }}"></i>
            </span>
            <app-search-text-input
              [field]="'by_name'"
              [value]="filterCriteria.by_name"
              [pattern]="'text'"
              [placeHolder]="'NAME'"
              (searched)="onSearched($event)"
            >
            </app-search-text-input>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <div class="input-group">
            <span class="input-group-addon">
              <i class="fa fa-calendar" title="{{ 'SEASONS' | translate }}"></i>
            </span>
            <mat-select
              (selectionChange)="filterSeasons('by_current_seasons', $event.value)"
              formControlName="by_current_seasons"
            >
              <mat-option *ngFor="let option of seasonOptions" [value]="option.value">
                {{ option.label | uppercase | translate }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div *ngIf="meta.itemsFound > 0">
    <table class="table table-striped table-hover table-highlight-head table-vertical-align">
      <thead>
        <tr>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'name'"
              (sorted)="onSorted($event)"
            >
              {{ 'NAME' | translate }}
            </app-sort-by>
          </th>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'from'"
              (sorted)="onSorted($event)"
            >
              {{ 'INITIAL_DATE' | translate }}
            </app-sort-by>
          </th>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'to'"
              (sorted)="onSorted($event)"
            >
              {{ 'FINAL_DATE' | translate }}
            </app-sort-by>
          </th>
          <th style="width: 60px" class="align-center">
            <a
              (click)="reloadSeasons()"
              title="{{ 'REFRESH' | translate }}"
              class="btn btn-xs btn-transparent"
            >
              <i class="fa fa-refresh"></i>
            </a>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="let season of seasons"
          id="{{ season.id }}"
          [ngClass]="{ 'alert-warning': season.to < today && season.status === 'active' }"
        >
          <!-- Name -->
          <td
            (click)="selectSeason(season)"
            [ngClass]="utilService.checkItemStatus(season.status)"
            class="cursor"
          >
            {{ season.name }}
            <span
              class="icol-error pull-right"
              *ngIf="season.to < today && season.status === 'active'"
              title="{{ 'OUTDATED_SEASON' | translate }}"
            ></span>
          </td>

          <!-- From -->
          <td
            (click)="selectSeason(season)"
            [ngClass]="utilService.checkItemStatus(season.status)"
            class="cursor"
          >
            {{ season.from | dateFormat: dateDisplay }}
          </td>

          <!-- To -->
          <td
            (click)="selectSeason(season)"
            [ngClass]="utilService.checkItemStatus(season.status)"
            class="cursor"
          >
            {{ season.to | dateFormat: dateDisplay }}
          </td>

          <td class="align-center">
            <div class="btn-group">
              <span class="dropdown-toggle btn btn-xs btn-transparent" data-toggle="dropdown">
                <i class="fa fa-ellipsis-h fa-lg"></i>
              </span>
              <ul class="dropdown-menu pull-right">
                <!-- Edit -->
                <li *ngIf="permissions.canShow">
                  <a href (click)="selectSeason(season, 'edit')">
                    <i class="fa fa-pencil"></i> {{ 'EDIT' | translate }}
                  </a>
                </li>

                <!-- Activate/Deactivate -->
                <li *ngIf="permissions.canUpdate">
                  <a href (click)="changeSeasonStatus(season)">
                    <i
                      [ngClass]="
                        season.status === 'active' ? 'fa fa-minus-square' : 'fa fa-check-square'
                      "
                    ></i>
                    {{
                      season.status === 'active'
                        ? ('DEACTIVATE' | translate)
                        : ('ACTIVATE' | translate)
                    }}
                  </a>
                </li>

                <!-- Copy season -->
                <li *ngIf="permissions.canUpdate" class="divider"></li>
                <li *ngIf="permissions.canUpdate">
                  <a href (click)="copySeason(season.id)">
                    <i class="fa fa-files-o fa-sized"></i> {{ 'COPY_SEASON' | translate }}
                  </a>
                </li>

                <!-- Delete -->
                <li *ngIf="permissions.canDestroy" class="divider"></li>
                <li *ngIf="permissions.canDestroy">
                  <a href (click)="deleteSeason(season)">
                    <i class="fa fa-trash"></i> {{ 'DELETE' | translate }}</a
                  >
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <app-table-footer
      [meta]="meta"
      (selectedPage)="onSelectedPage($event)"
      *ngIf="meta.totalPages > 1"
    ></app-table-footer>
  </div>

  <div *ngIf="meta.itemsFound === 0" class="alert alert-warning align-center" style="padding: 40px">
    <i class="fa fa-ban fa-4x"></i>
    <h3>{{ 'NO_ITEMS_FOUND' | translate }}</h3>

    <a href (click)="clearSearchForm()">
      <i class="fa fa-times"></i> {{ 'CLEAR_SEARCH' | translate }}
    </a>
  </div>
</div>

<div
  *ngIf="seasons && meta.totalItems === 0"
  class="alert alert-info align-center"
  style="padding: 40px"
>
  <i class="fa fa-ban fa-4x"></i>
  <h5>{{ 'NO_ITEMS_FOUND' | translate }}</h5>
</div>
